import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Lock } from "lucide-react";

// Sprint 8.A.2 — Subtiler Conversion-Banner am unteren Rand für Free-User.
// Sticky-bottom, 60% Opacity, slide-up Animation, dismissible (Session-only).

export default function CockpitFreeBanner({ onCta }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 60, opacity: 0 }}
        animate={{ y: 0, opacity: 0.95 }}
        exit={{ y: 60, opacity: 0 }}
        transition={{ type: "spring", stiffness: 200, damping: 22 }}
        data-testid="cockpit-free-banner"
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-30 max-w-3xl w-[calc(100%-2rem)]"
      >
        <div
          className="rounded-2xl shadow-xl px-5 py-3 flex items-center gap-3 backdrop-blur"
          style={{ backgroundColor: "rgba(15, 23, 42, 0.92)" }}
        >
          <Lock className="w-4 h-4 text-amber-300 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            {/* Sprint Pricing V1 Block B (02.09.2026) — Continuitäts-Linie
                wörtlich per Andreas-Direktive 15:55. Nicht variieren. */}
            <p
              className="text-sm font-bold text-white"
              data-testid="cockpit-free-banner-continuity-line"
            >
              Pro Monat 39 €/Monat, wenn du bereit bist. Jederzeit kündbar.
            </p>
          </div>
          <button
            type="button"
            onClick={onCta}
            data-testid="cockpit-free-banner-cta"
            className="rounded-full bg-[#4563BB] hover:bg-[#3a55a5] text-white px-4 py-1.5 text-xs font-bold whitespace-nowrap"
          >
            Jetzt freischalten
          </button>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            aria-label="Banner schließen"
            data-testid="cockpit-free-banner-dismiss"
            className="text-slate-400 hover:text-white"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
